import { type FunctionComponent, lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterCuratePageProjectScenarioExportRedirect = lazy(() => {
  return new Promise<{ default: FunctionComponent }>((resolve, reject) => {
    import("@honeycomb/curate/curate.css");
    import("@honeycomb/curate")
      .then((lib) => {
        resolve({
          default: () => <lib.PageProjectScenarioExportRedirect />,
        });
      })
      .catch(reject);
  });
});

export const LazyCuratePageProjectScenarioExportRedirect = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterCuratePageProjectScenarioExportRedirect />
    </Suspense>
  );
};
